export default "__VITE_ASSET__CKKbwj03__"